import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const UnorderedList = ({ node }: RichTextContentProps) => {
  return (
    <ul>
      <RichTextContent node={node} />
    </ul>
  );
};

export default UnorderedList;
